import React from 'react'
import { Link, usePage } from '@inertiajs/inertia-react'
import Layout from '../../../../Shared/Layout/LayoutAdmin'
import Breadcrumbs from '../../../../Shared/Components/Breadcrumbs'

const Index = ({ exams }) => {
    const { flash } = usePage().props

    return (
        <>
            <div className="mb-5 mt-5">
                <Breadcrumbs currentPath="/admin/sia/manage/examenes" />
            </div>
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-6">
                <h1 className="fs-2 fw-bold text-gray-900 mb-0">Exámenes</h1>
                <div className="d-flex gap-2">
                    <Link href={route('sia.manage.exams.results')} className="btn btn-sm btn-light-primary">Resultados</Link>
                    <Link href={route('sia.manage.exams.create')} className="btn btn-sm btn-primary">Nuevo examen</Link>
                </div>
            </div>
            {flash?.success && <div className="alert alert-success">{flash.success}</div>}
            {flash?.error && <div className="alert alert-danger">{flash.error}</div>}
            <div className="card">
                <div className="card-body">
                    <table className="table table-row-dashed align-middle gs-0 gy-3">
                        <thead>
                            <tr className="fw-bold text-gray-500">
                                <th>Subcategoría</th>
                                <th>Título</th>
                                <th>Preguntas</th>
                                <th>Segundos</th>
                                <th>Intentos</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {exams.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-muted py-6">Todavía no hay exámenes.</td>
                                </tr>
                            )}
                            {exams.map((exam) => (
                                <tr key={exam.id}>
                                    <td className="fw-semibold">{exam.section}</td>
                                    <td>{exam.title}</td>
                                    <td>{exam.questions_count}</td>
                                    <td>{exam.seconds_per_question} s</td>
                                    <td>{exam.attempts_count}</td>
                                    <td className="text-end">
                                        <Link href={route('sia.manage.exams.edit', exam.slug)} className="btn btn-sm btn-light-primary">Editar</Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

Index.layout = (page) => <Layout title="Exámenes SIA">{page}</Layout>

export default Index
